import {
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Select,
  Button,
  Box,
  Modal,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import _ from "lodash";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { useDispatch, useSelector } from "react-redux";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addGoodsInFormValidationSchema } from "src/helpers/yup_schema";
import { getAllClientsWithProjects } from "src/thunks/clientProjects";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import toastMessages from "src/constant/toastMessages.json";
import {
  addNewGoodsInData,
  getAllGoodsInData,
  editGoodsInRecord,
  getGoodsInSingleData,
  getAllGoodsInData1,
} from "src/thunks/goodsin";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import {
  commonFileUpload,
  getAllNofificationForDashboard,
} from "src/thunks/dashboard";
import { useParams } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { GetError, AddingZeroOnTime, getFloatValue } from "src/constant";
import UploadImage from "src/components/GoodsinImageModal";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CollectionsIcon from '@mui/icons-material/Collections';
// import {uploadImage} from "src/components/GoodsinImageModal/index"

export const GoodsForm = ({ handleClose, editData, getAllGoodsIn, currentPage, isReview, searchValue }) => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const allDeportsdata = useSelector(
    (state) => state?.depotUsers?.depoData || []
  );
  const { allClientsWithProjects } = useSelector(
    (state) => state?.clientProjects
  );
  const lookupValues = useSelector((state) => state.lookup.data);
  const { addNewGoodsInLoading } = useSelector((state) => state.goodsin);


  const { filterAllData } = useSelector((state) => state.goodsin);
  const filterData = filterAllData["goodsIn"]

  /** hooks useState ----------------------------------------------------- **/
  const [open, setOpen] = useState(false);
  const [allItem, setallItem] = useState([]);
  const [newImagesArray, setNewImagesArray] = useState([]);
  const [loader, setLoader] = useState(false);
  const [projectArray, setProjectArray] = useState([]);
  const [projectManagersArray, setProjectManagersArray] = useState([]);
  const [depotManagersArray, setDepotManagersArray] = useState([]);
  const [refNumberError, setRefNumberError] = useState("");
  const [photoLoader, setPhotoLoader] = useState(false);
  const [documentLoader, setDocumentLoader] = useState(false);
  const [GoodsInStateData, _GoodsInStateData] = useState({
    vrn: "",
    driverName: "",
    driverContact: "",
    referenceNumber: "",
    internalSpaceOccupied: "",
    externalSpaceOccupied: "",
    type: "New",
    date: new Date(),
    time1: moment().hour(),
    time2: moment().minute(),
    isBackdatedEntry: false,
  });
  const [Item, setItem] = useState({
    condition: "Good",
    description: "",
    itemNumber: "",
    quantityReceived: "",
    storage: "",
    shipmentItemEvidences: [],
  });
  const [ItemError, setItemError] = useState({
    description: "",
    itemNumber: "",
    quantityReceived: "",
    storage: "",
  });
  const [unitsNewCount, setUnitsNewCount] = useState(0)
  const [ItemDataForShowImage, setItemDataForShowImage] = useState(null)

  /** variable declarations ----------------------------------------------------- **/
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const shownData = editData;
  const params = useParams();
  let shipmentId = parseInt(params.id);
  let PhotoType = lookupValues?.find((v) => v.name === "Pictures")?.id;
  let DocumentType = lookupValues?.find((v) => v.name === "Documents")?.id;
  let imagesCount = _.filter(
    newImagesArray || [],
    (d) => d.typeId == PhotoType
  ).length;
  let documentCount = _.filter(
    newImagesArray || [],
    (d) => d.typeId == DocumentType
  ).length;

  const {
    register,
    watch,
    handleSubmit,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(addGoodsInFormValidationSchema),
  });

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    dispatch(getAllClientsWithProjects());
  }, []);

  useEffect(() => {
    if (shownData) {
      resetData(shownData);
    }
  }, [JSON.stringify(shownData)]);

  useEffect(() => {
    if (userDetails?.roles == "DepotManager") {
      resetDMData();
    }
  }, []);

  useEffect(() => {
    if (allClientsWithProjects?.length > 0 && shownData?.clientId) {
      const clientData = allClientsWithProjects.find(
        (item) => item.id === shownData?.clientId
      );
      setProjectArray(clientData?.projects || []);
    }
  }, [allClientsWithProjects]);

  useEffect(() => {
    const projectData = projectArray.find(
      (item) => item.id == shownData?.projectId
    );
    setProjectManagersArray(projectData?.users || []);
  }, [projectArray]);

  useEffect(() => {
    if (allDeportsdata?.length > 0 && shownData?.depotId) {
      const depotManagersArray = allDeportsdata.find(
        (item) => item.id == shownData?.depotId
      );
      setDepotManagersArray(depotManagersArray?.depotUsers || []);
    }
  }, [allDeportsdata]);

  /** handler functions--------------------------------------------------- **/
  const handleClosemodal = () => {
    setItemDataForShowImage(null)
    setOpen(false);
  }
  const resetDMData = () => {
    _GoodsInStateData({
      ...GoodsInStateData,
      depotId: shownData ? shownData?.depotId : userDetails?.depots[0]?.id,
      depotManagerId: shownData ? shownData?.depotManager?.id : userDetails?.id,
    });
    reset({
      depotName: shownData ? shownData?.depotId : userDetails?.depots[0]?.id,
      depotManagerName: shownData
        ? shownData?.depotManager?.id
        : userDetails?.id,
    });
  };

  const resetData = (data) => {
    setTimeout(() => {
      reset({
        vrn: data?.vrn,
        driverContact: data?.driverContact,
        driverName: data?.driverName,
        depotName: data?.depotId,
        depotManagerName: data?.depotManager?.id,
        client: data?.clientId,
        project: data?.projectId,
        projectManager: data?.projectManager?.id,
        internalSpaceOccupied: data?.internalSpaceOccupied || "",
        externalSpaceOccupied: data?.externalSpaceOccupied || "",
      });
      _GoodsInStateData({
        ...GoodsInStateData,
        depotId: data?.depotId || "",
        depotManagerId: data?.depotManager?.id || "",
        clientId: data?.clientId || "",
        projectId: data?.projectId || "",
        type: data?.type || "",
        vrn: data?.vrn || "",
        driverName: data?.driverName || "",
        driverContact: data?.driverContact || "",
        referenceNumber: data?.referenceNumber,
        projectManagerId: data?.projectManager?.id || "",
        internalSpaceOccupied: data?.internalSpaceOccupied || "",
        externalSpaceOccupied: data?.externalSpaceOccupied || "",
        date: data && data.date && data.date ? new Date(data.date) : new Date(),
        time1:
          (data?.time?.split(":")[0] &&
            parseInt(data?.time?.split(":")[0], 10).toString()) ||
          moment().hour(),
        time2:
          (data?.time?.split(":")[1] &&
            parseInt(data?.time?.split(":")[1], 10).toString()) ||
          moment().minutes(),
      });
      setallItem([...data?.items]);
      const processedData = data?.shipmentEvidences.map((result) => ({
        ...result,
        isToBeDeleted: false,
        shipmentId: shipmentId,
      }));
      setNewImagesArray([...processedData]);
    }, 1000);
  };

  const allOnChangeHandler = (title, value) => {
    _GoodsInStateData({ ...GoodsInStateData, [title]: value });
  };

  const handleDepotNameChange = (event, values) => {
    setDepotManagersArray(values?.depotUsers || []);
    allOnChangeHandler("depotId", values.id);
    clearErrors("depotName");
  };

  const handleDepotManagerNameChange = (event, values) => {
    clearErrors("depotManagerName");
    allOnChangeHandler("depotManagerId", values?.userId);
  };

  const handleClientNameChange = (event, values) => {
    clearErrors("client");
    allOnChangeHandler("clientId", values?.id);
    setProjectArray(values?.projects || []);
  };

  const handleProjectNameChange = (event, values) => {
    clearErrors("project");
    allOnChangeHandler("projectId", values?.id);
    setProjectManagersArray(values?.users || []);
  };

  const handleProjectManagerNameChange = (event, values) => {
    clearErrors("projectManager");
    allOnChangeHandler("projectManagerId", values?.userId);
  };

  const photoUpload = async (e) => {
    setPhotoLoader(true);
    const files = e.target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    try {
      let res = await dispatch(commonFileUpload(formData)).unwrap();
      let PhotoType = lookupValues.find((v) => v.name === "Pictures").id;
      setPhotoLoader(false);
      const processedData = res.map((result) => ({
        ...result,
        type: PhotoType,
        isDamaged: false,
        isToBeDeleted: null,
        shipmentId: shipmentId,
      }));

      processedData &&
        processedData[0] &&
        processedData.forEach((item) => {
          setNewImagesArray((prevState) => {
            return [
              ...prevState,
              {
                url: item.url,
                uniqueFileId: item.uniqueFileId,
                fileName: item.fileName,
                isDamaged: item.isDamaged,
                typeId: item.type,
                isToBeDeleted: item.isToBeDeleted,
                shipmentId: item.shipmentId,
              },
            ];
          });
        });
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");

      setPhotoLoader(false);
    }
  };

  const documentUpload = async (e) => {
    setDocumentLoader(true);
    const files = e.target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    try {
      let res = await dispatch(commonFileUpload(formData)).unwrap();
      setDocumentLoader(false);
      let documentType = lookupValues.find((v) => v.name === "Documents").id;
      const processedData = res.map((result) => ({
        ...result,
        type: documentType,
        isDamaged: false,
        isToBeDeleted: null,
        shipmentId: shipmentId,
      }));
      processedData &&
        processedData[0] &&
        processedData.forEach((item) => {
          setNewImagesArray((prevState) => {
            return [
              ...prevState,
              {
                url: item.url,
                uniqueFileId: item.uniqueFileId,
                fileName: item.fileName,
                isDamaged: item.isDamaged,
                typeId: item.type,
                isToBeDeleted: item.isToBeDeleted,
                shipmentId: item.shipmentId,
              },
            ];
          });
        });
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");

      setDocumentLoader(false);
    }
  };
  const checkValidation = () => {
    let errors = {};
    [
      "itemNumber",
      "description",
      "storage",
      "quantityReceived",
    ].map((d) => {

      if (!Item[`${d}`]) {
        errors[`${d}`] = `Add ${d}`;
      } else {
        delete errors[`${d}`];
      }
    });
    return errors;
  };
  // ---------------------------------
  const addGoodsItem = () => {
    let errors = checkValidation();
    if (Object.keys(errors).length > 0) {
      setItemError({
        ...ItemError,
        ...errors,
      });
    } else {
      setItemError({
        ...ItemError,
        description: "",
        itemNumber: "",
        storage: "",
        quantityReceived: "",
      });
      setItem({ ...Item });
    }
    if (Object.keys(errors).length == 0) {
      setallItem([...allItem, { shipmentItemEvidences: [], ...Item }]);
      ClearItemData();
    }
  };

  const getGoodsInDataFunc = async () => {
    setLoader(true);
    try {
      await dispatch(getGoodsInSingleData({ id: shipmentId || "22" })).unwrap();
      setLoader(false);
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");

      setLoader(false);
    }
  };

  const getAllGoodsInDataFunc = async () => {
    setLoader(true);
    try {
      let data = {
        isDateRange: false,
        from: moment(filterData?.fromDate).format("YYYY-MM-DD"),
        DepotIds: [0],
        ClientIds: [0],
        ProjectIds: [0],
      };
      await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      setLoader(false);
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");

      setLoader(false);
    }
  };

  const handleDriverChange = (e) => {
    allOnChangeHandler("driverName", e.target.value);
    clearErrors("driverName");
  };

  const handleDriverContactChange = (e) => {
    allOnChangeHandler("driverContact", e.target.value);
    const phoneRegex = /^[0-9 -]*$/;
    let emailFlag = phoneRegex.test(e.target.value);
    if (emailFlag) {
      clearErrors("driverContact");
    }
  };

  const handleVrnChange = (e) => {
    allOnChangeHandler("vrn", e.target.value);
    clearErrors("vrn");
  };

  const onGoodsInFormSubmitHandler = async (data) => {
    if (GoodsInStateData.referenceNumber == "") {
      setRefNumberError("Reference number required");
    }
    if (allItem.length <= 0) {
      toast.error("please add at least one item");
    }

    let newData = {
      ...GoodsInStateData,
      internalSpaceOccupied: GoodsInStateData?.internalSpaceOccupied || 0,
      externalSpaceOccupied: GoodsInStateData?.externalSpaceOccupied || 0,
    };
    newData["typeId"] =
      _.find(lookupValues, (d) => d.name === newData.type)?.id || 0;
    newData.depotCode =
      _.find(allDeportsdata, (d) => d.id === newData.depotId)?.code || "";
    newData.ClientName = data?.client;
    newData["role"] = userDetails?.roles;

    if (newData.time2) {
      newData["date"] = moment(newData.date).format("YYYY-MM-DD");
    }
    newData["time"] = `${AddingZeroOnTime(newData?.time1 || "00")}:${AddingZeroOnTime(
      newData?.time2 || "00"
    )}:35`;

    newData["items"] = _.map(allItem, (d) => {
      let temp = { ...d };
      temp.conditionId =
        _.find(lookupValues, (d1) => d1.name === d?.condition)?.id || 0;
      temp.storageId =
        _.find(lookupValues, (d1) => d1.name === d?.storage)?.id || 0;
      delete temp?.condition;
      delete temp?.storage;
      return temp;
    });

    const modifiedData = newImagesArray.map((item) => {
      const { shipmentId, isToBeDeleted, ...rest } = item;
      return rest;
    });

    newData["shipmentEvidences"] = !editData ? modifiedData : newImagesArray;
    if (GoodsInStateData.referenceNumber !== "" && allItem.length > 0) {
      try {
        let result = await dispatch(
          editData
            ? editGoodsInRecord({ ...newData, id: shipmentId })
            : addNewGoodsInData(newData)
        ).unwrap();
        if (!editData) {
          getAllGoodsIn(currentPage, isReview, searchValue);
        } else {
          getGoodsInDataFunc();
        }
        if (result) {
          if (userDetails?.roles == "SuperAdmin") {
            setTimeout(() => {
              dispatch(getAllNofificationForDashboard(1, 20));
            }, 2000);
          }
          toast.success(
            editData ? toastMessages.goodsinEdited : toastMessages.goodsinAdded
          );
          handleClose();
        }
      } catch (err) {
        toast.error(GetError(err?.response?.data?.errors) || "something issue");
      }
    }
  };

  const ItemOncHangeData = (title, value) => {
    setItem({ ...Item, [title]: value });
  };

  const ClearItemData = () => {
    setItem({
      condition: "Good",
      description: "",
      itemNumber: "",
      quantityReceived: "",
      storage: "",
    });
    setItemError({
      description: "",
      itemNumber: "",
      quantityReceived: "",
      storage: "",
    });
  };

  const handleRefNumberChange = (target) => {
    allOnChangeHandler("referenceNumber", target.value);
    setRefNumberError("");
  };

  const handleReturnCheckClick = (target) => {
    let checked = target?.checked || false;
    _GoodsInStateData({
      ...GoodsInStateData,
      type: checked ? "Return" : "New",
      referenceNumber: checked ? RandomeReturnNumberGenrate("RETURN", 4) : "",
    });
    if (target.checked) {
      setRefNumberError("");
    }
  };

  const handleItemNumberChange = (target) => {
    ItemOncHangeData("itemNumber", target.value);
  };

  const handleItemDescriptionChange = (target) => {
    ItemOncHangeData("description", target.value);
    clearErrors("itemDescription");
  };

  const handleItemUnitsChange = (target) => {
    ItemOncHangeData("quantityReceived", parseInt(target.value));
    clearErrors("itemUnits");
  };

  const handleRemoveItemIconClickFromTable = (item) => {
    const result = allItem.filter(
      (data) => data.itemNumber !== item.itemNumber
    );
    setallItem([...result]);

    let interiorCountItem = _.filter(result, d => d.storage === "interior")
    let exteriorCountItem = _.filter(result, d => d.storage !== "interior")

    _GoodsInStateData({
      ...GoodsInStateData,
      internalSpaceOccupied: interiorCountItem?.length > 0 ? GoodsInStateData?.internalSpaceOccupied : "",
      externalSpaceOccupied: exteriorCountItem?.length > 0 ? GoodsInStateData?.externalSpaceOccupied : ""
    })
  };

  function makeid(length) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const generateItemNumberFromDepotName = () => {
    if (GoodsInStateData.depotId) {
      return _.find(
        allDeportsdata || [],
        (d) => d.id == GoodsInStateData.depotId
      )?.code;
    } else {
      return "MUZ";
    }
  };

  function makeReturnId(length) {
    let result = "";
    const characters = "0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const RandomeItemGenrate = (string, number) => {
    return string + makeid(number);
  };

  const RandomeReturnNumberGenrate = (string, number) => {
    return string + makeReturnId(number);
  };

  let damageCount =
    _.filter(allItem, (d) => d.condition === "Damaged")?.length || 0;

  useEffect(() => {
    let unitsCount = _.sumBy(allItem, (d) => d.quantityReceived || 0) || 0;
    setUnitsNewCount(unitsCount)
  }, [allItem])

  const IsDamageChangeHandler = (ichecked, id) => {
    let filesArrayMapedData = _.map(newImagesArray, (d) => {
      let temp = { ...d };
      if (d.uniqueFileId === id) {
        temp.isDamaged = ichecked;
      }
      return temp;
    });
    setNewImagesArray([...filesArrayMapedData]);
  };
  const handleQuantityChange = (newValue, itemNumber) => {
    if (newValue !== "0") {
      let cloneAllItem = _.cloneDeep(allItem);
      let FindIncrementData = _.findIndex(
        cloneAllItem,
        (d) => d.itemNumber === itemNumber
      );
      cloneAllItem[FindIncrementData]["quantityReceived"] = parseInt(newValue);
      setallItem([...cloneAllItem]);
    }
  };

  const sortdepotManagersArray = _.orderBy(_.map(depotManagersArray, (d) => {
    return {
      ...d,
      newName: d.firstName + " " + d.lastName
    }
  }), ['newName'], ['asc'])

  const sortprojectManagersArray = _.orderBy(_.map(projectManagersArray, (d) => {
    return {
      ...d,
      newName: d.firstName + " " + d.lastName
    }
  }), ['newName'], ['asc'])

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '46%',
    transform: 'translate(-50%, -50%)',
    width: "40%",
    height: '70%',
    bgcolor: 'background.paper',
    overflowY: "scroll",
  };

  let interiorCountItem = _.filter(allItem, d => d.storage === "interior")
  let exteriorCountItem = _.filter(allItem, d => d.storage !== "interior")

  return (
    <div style={{ marginTop: 10 }} className="goodsin-form">
      <div style={{ paddingLeft: 50, paddingRight: 50 }}>
        <form onSubmit={handleSubmit(onGoodsInFormSubmitHandler)}>
          <div className="row pt-5" style={{ height: 100 }}>
            <div className="col-md-3" style={{ paddingTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={GoodsInStateData.date}
                  label="Date"
                  onChange={(newValue) => allOnChangeHandler("date", newValue)}
                  className="DatePickerOutline"
                  variant="standard"
                  id="standard-basic"
                  format="dd.MM.yyyy"
                />
              </LocalizationProvider>
            </div>
            <div className="col-md-9">
              <div className="row d-flex" style={{ position: "relative" }}>
                <label
                  style={{
                    position: "absolute",
                    top: -6,
                    color: "#80a2ec",
                    padding: 0,
                  }}
                >
                  TIME
                </label>
                <div
                  className="col-md-3 pr-0 pl-0"
                  style={{ paddingTop: 12, paddingRight: 0, paddingLeft: 0 }}
                >
                  <select
                    value={GoodsInStateData.time1}
                    onChange={({ target }) =>
                      allOnChangeHandler("time1", target.value)
                    }
                    style={{
                      textAlign: "center",
                      borderTop: 0,
                      borderLeft: 0,
                      borderRight: 0,
                      borderBottom: "1px solid #5e89e7",
                      height: 42,
                    }}
                  >
                    {[...Array(24)].map((d, index) => {
                      const formattedValue = index.toString().padStart(2, '0');
                      return (
                        <option key={index} value={index}>
                          {/* {index} */}
                          {formattedValue}
                        </option>
                      );
                    })}
                  </select>
                  :
                  <select
                    value={GoodsInStateData.time2}
                    onChange={({ target }) =>
                      allOnChangeHandler("time2", target.value)
                    }
                    style={{
                      textAlign: "center",
                      marginLeft: 3,
                      borderTop: 0,
                      borderLeft: 0,
                      borderRight: 0,
                      borderBottom: "1px solid #5e89e7",
                      height: 42,
                    }}
                  >
                    {[...Array(60)].map((d, index) => {
                      const formattedValue = index.toString().padStart(2, "0");
                      if (index === 0) {
                        return <option key={index}>{"00"}</option>;
                      }
                      // return <option key={index}>{index}</option>;
                      return (
                        <option key={index} value={index}>
                          {formattedValue}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-5 pr-0 pl-0">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={_.orderBy(userDetails?.roles == "DepotManager" ? userDetails?.depots : allDeportsdata, ['name'], ['asc'])}
                    onChange={handleDepotNameChange}
                    defaultValue={{
                      name:
                        userDetails?.roles == "DepotManager" && !shownData
                          ? userDetails?.depots[0]?.name
                          : shownData?.depotName,
                    }}
                    getOptionLabel={(item) =>
                      typeof item.name == "string" ? item.name : ""
                    }
                    disabled={
                      userDetails?.roles == "DepotManager" &&
                        (userDetails?.depots).length <= 1
                        ? true
                        : false
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        {...register("depotName")}
                        label="DEPOT"
                        variant="standard"
                        id="standard-basic"
                        style={{ height: 42 }}
                      />
                    )}
                  />
                  <span className="errors-msg-shown-for-goodsin">
                    {errors.depotName?.message && errors.depotName?.message}
                  </span>
                </div>

                <div className="col-md-4 pr-0 pl-0">
                  <Autocomplete
                    disablePortal
                    onChange={handleDepotManagerNameChange}
                    id="combo-box-demo"
                    defaultValue={{
                      firstName:
                        userDetails?.roles == "DepotManager"
                          ? userDetails?.firstName
                          : shownData?.depotManager?.firstName,
                      lastName:
                        userDetails?.roles == "DepotManager"
                          ? userDetails?.lastName
                          : shownData?.depotManager?.lastName,
                    }}
                    getOptionLabel={(item) =>
                      item.firstName || item.lastName
                        ? item.firstName + " " + item.lastName
                        : ""
                    }
                    disabled={
                      userDetails?.roles == "DepotManager" ? true : false
                    }
                    options={sortdepotManagersArray}
                    renderInput={(params) => (
                      <TextField
                        {...register("depotManagerName")}
                        {...params}
                        label="MANAGER"
                        variant="standard"
                        id="standard-basic"
                        style={{ height: 42 }}
                      />
                    )}
                  />
                  <span className="errors-msg-shown-for-goodsin">
                    {errors.depotManagerName?.message &&
                      errors.depotManagerName?.message}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-2" style={{ height: 80 }}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-4">
                  <TextField
                    onChange={({ target }) => handleRefNumberChange(target)}
                    label="CMR / REFERENCE NUMBER"
                    variant="standard"
                    id="standard-basic"
                    style={{ height: 42, width: "100%" }}
                    value={GoodsInStateData.referenceNumber}
                  />
                  <span className="errors-msg-shown-for-goodsin">
                    {(refNumberError && refNumberError) || ""}
                  </span>
                </div>
                <div
                  className="col-md-3"
                  style={{ paddingLeft: 0, marginTop: 16 }}
                >
                  <div
                    className="return-checkbox-style"
                    style={{ display: "flex", marginTop: -7 }}
                  >
                    <Checkbox
                      checked={GoodsInStateData.type == "Return" ? true : false}
                      style={{ color: "#0045D9", fontSize: 19 }}
                      onChange={({ target }) => handleReturnCheckClick(target)}
                    />
                    <InputLabel
                      style={{ marginTop: 5 }}
                      className="return-keyword-style"
                    >
                      {" "}
                      RETURN
                    </InputLabel>
                  </div>
                </div>
                <div className="col-md-5 pr-0 pl-0">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={_.orderBy(allClientsWithProjects, ['name'], ['asc'])}
                    getOptionLabel={(item) =>
                      typeof item.name == "string" ? item.name : ""
                    }
                    renderOption={(props, option) => {
                      return (<li {...props} key={option.id}>{option.name}</li>)
                    }}
                    onChange={handleClientNameChange}
                    defaultValue={{
                      name: shownData?.clientName || [],
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...register("client")}
                        {...params}
                        label="CLIENT"
                        variant="standard"
                        id="standard-basic"
                        style={{ height: 42 }}
                      />
                    )}
                  />
                  <span className="errors-msg-shown-for-goodsin">
                    {errors.client?.message && errors.client?.message}
                  </span>
                </div>
                <div className="col-md-2"></div>
              </div>
            </div>
          </div>
          <div className="row pt-2" style={{ height: 40 }}>
            <div className="col-md-6">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={_.orderBy(projectArray, ['name'], ['asc'])}
                getOptionLabel={(item) =>
                  typeof item.name == "string" ? item.name : ""
                }
                defaultValue={{ name: shownData?.projectName || [] }}
                onChange={handleProjectNameChange}
                renderInput={(params) => (
                  <TextField
                    {...register("project")}
                    {...params}
                    label="PROJECT"
                    variant="standard"
                    id="standard-basic"
                    style={{ height: 42 }}
                  />
                )}
              />
              <span className="errors-msg-shown-for-goodsin">
                {errors.project?.message && errors.project?.message}
              </span>
            </div>
            <div className="col-md-6">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={sortprojectManagersArray}
                onChange={handleProjectManagerNameChange}
                defaultValue={{
                  firstName: shownData?.projectManager?.firstName || [],
                  lastName: shownData?.projectManager?.lastName || [],
                }}
                getOptionLabel={(item) =>
                  item.firstName || item.lastName
                    ? item.firstName + " " + item.lastName
                    : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...register("projectManager")}
                    {...params}
                    label="PROJECT MANAGER"
                    variant="standard"
                    id="standard-basic"
                    style={{ height: 42 }}
                  />
                )}
              />
              <span className="errors-msg-shown-for-goodsin">
                {errors.projectManager?.message &&
                  errors.projectManager?.message}
              </span>
            </div>
          </div>
          <div className="row pt-3 pb-0 mb-2 mt-4 ps-1">
            <InputLabel className="goodsin-form-section-header-name">
              {" "}
              VEHICLE
            </InputLabel>
          </div>
          <div className="row" style={{ height: 65 }}>
            <div className="col-md-4">
              <TextField
                label="VRN"
                {...register("vrn")}
                value={GoodsInStateData?.vrn}
                onChange={(e) => handleVrnChange(e)}
                variant="standard"
                id="standard-basic"
                style={{ height: 42, width: "100%" }}
              />
              <span className="errors-msg-shown-for-goodsin">
                {errors.vrn?.message && errors.vrn?.message}
              </span>
            </div>
            <div className="col-md-4">
              <TextField
                {...register("driverName")}
                label="DRIVER"
                value={GoodsInStateData.driverName}
                onChange={(e) => handleDriverChange(e)}
                variant="standard"
                id="standard-basic"
                style={{ height: 42, width: "100%" }}
              />
              <span className="errors-msg-shown-for-goodsin">
                {errors.driverName?.message && errors.driverName?.message}
              </span>
            </div>
            <div className="col-md-4">
              <TextField
                {...register("driverContact")}
                value={GoodsInStateData.driverContact}
                label="DRIVER CONTACT"
                type="string"
                onChange={(e) => handleDriverContactChange(e)}
                variant="standard"
                id="standard-basic"
                style={{ height: 42, width: "100%" }}
              />
              <span className="errors-msg-shown-for-goodsin">
                {errors.driverContact?.message && errors.driverContact?.message}
              </span>
            </div>
          </div>


          <div className="row pt-1 mt-4">
            <table
              className="table goodsin-table table-borderless p-0"
              style={{ width: "100%" }}
            >
              <thead className="goodsin-table-header">
                <tr>
                  <th
                    scope="col"
                    className={` text-uppercase text-primary set-header-width-for-long-text`}
                  >
                    Image
                  </th>
                  <th
                    scope="col"
                    className={`text-uppercase text-primary set-header-width-for-long-text`}
                  >
                    <span className="items-table-header-count">
                      {allItem?.length || 0}
                    </span>
                    <span className="items-table-text"> ITEMS</span>
                  </th>
                  <th
                    scope="col"
                    className={` text-uppercase text-primary set-header-width-for-long-text`}
                  >
                    <span className="items-table-header-count">
                      {damageCount}
                    </span>
                    <span className="items-table-text"> DAMAGED</span>
                  </th>
                  <th
                    scope="col"
                    className={`text-uppercase text-primary set-header-width-for-medium-text`}
                  >
                    <span className="items-table-text">DESCRIPTION</span>
                  </th>
                  <th
                    scope="col"
                    className={`text-uppercase text-primary set-header-width-for-long-text`}
                  >
                    <span className="items-table-header-count">
                      {/* {unitsCount} */}
                      {unitsNewCount}
                    </span>
                    <span className="items-table-text"> UNITS</span>
                  </th>

                  <th
                    scope="col"
                    className={` text-uppercase text-primary set-header-width-for-long-text`}
                  >
                  </th>
                </tr>
              </thead>
              <tbody className="goods-table-body">
                {allItem?.length > 0 &&
                  _.orderBy(allItem || [], ["itemNumber"], ["asc"]).map(
                    (item, index) => {
                      return (
                        <tr key={index} className="goodsin-items-tr">
                          <td>
                            <Button
                              variant="outlined"
                              className="btn-bootstrap-submit-style"
                              style={{ height: 40, marginRight: 5 }}
                              // startIcon={<CancelIcon />}
                              onClick={() => {
                                setItemDataForShowImage(item)
                                setOpen(!open)
                              }}
                            >
                              {item?.shipmentItemEvidences?.length > 0 ?
                                <CollectionsIcon /> : <AddPhotoAlternateIcon />}
                            </Button>
                          </td>
                          <td>{item?.itemNumber}</td>
                          <td>{item?.condition}</td>
                          <td>{item?.description}</td>
                          <td>
                            <input
                              type="number" className="search-input-for-depot-personal-tab unit-item-range-style"
                              value={item?.quantityReceived}
                              style={{ width: "70%", height: 25 }}
                              onChange={(e) =>
                                handleQuantityChange(
                                  e.target.value,
                                  item.itemNumber
                                )
                              }
                            />
                          </td>


                          <td>
                            <div
                              className="d-flex justify-content-center align-items-center"
                              onClick={() =>
                                handleRemoveItemIconClickFromTable(item)
                              }
                            >
                              <RemoveCircleOutlineOutlinedIcon
                                className="remove-item-icon-color"
                                style={{ cursor: "pointer", color: "red" }}
                                fontSize="20"
                              />
                              <span
                                className="ms-1 remove-item-label-color"
                                style={{
                                  fontFamily: "Montserrat-Regular",
                                  fontSize: 10,
                                  cursor: "pointer",
                                  color: "red",
                                }}
                              >
                                REMOVE
                              </span>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
              </tbody>
            </table>
          </div>

          <div className="row pt-2">
            <div className="col-md-7" style={{ height: 70 }}>
              <div className="row">
                <div className="col-md-8">
                  <div style={{ position: "relative" }}>
                    <div>
                      <TextField
                        value={Item?.itemNumber}
                        onChange={({ target }) => {
                          handleItemNumberChange(target);
                          setItemError({ ...ItemError, itemNumber: "" });
                        }}
                        label="ITEM NUMBER"
                        variant="standard"
                        id="standard-basic"
                        style={{ height: 42, width: "100%" }}
                      />
                      <span className="errors-msg-shown-for-goodsin">
                        {ItemError?.itemNumber || ""}
                      </span>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 15,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        ItemOncHangeData(
                          "itemNumber",
                          RandomeItemGenrate(
                            generateItemNumberFromDepotName(),
                            7
                          )
                        );
                        setItemError({ ...ItemError, itemNumber: "" });
                      }}
                    >
                      <InputLabel style={{ marginTop: 5, fontSize: 12 }}>
                        {" "}
                        GENERATE
                      </InputLabel>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className="mt-3 return-checkbox-style d-flex"
                    style={{ marginTop: -7 }}
                  >
                    <Checkbox
                      style={{ color: "#E94F37", fontSize: 19 }}
                      checked={Item.condition === "Good" ? false : true}
                      onChange={({ target }) => {
                        if (target.checked) {
                          ItemOncHangeData(
                            "itemNumber",
                            RandomeItemGenrate("RETURN", 7)
                          );
                          ItemOncHangeData("condition", "Damaged");
                        } else {
                          ItemOncHangeData("itemNumber", "");
                          ItemOncHangeData("condition", "Good");
                        }
                      }}
                    />
                    <InputLabel
                      style={{ marginTop: 5 }}
                      className="return-keyword-style"
                    >
                      DAMAGED
                    </InputLabel>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <TextField
                value={Item.description}
                onChange={({ target }) => {
                  handleItemDescriptionChange(target);
                  setItemError({ ...ItemError, description: "" });
                }}
                label="DESCRIPTION"
                variant="standard"
                id="standard-basic"
                style={{ height: 42, width: "100%" }}
              />
              <span className="errors-msg-shown-for-goodsin">
                {ItemError?.description}
              </span>
            </div>
            <div className="col-md-7" style={{ height: 70 }}>
              <div className="row">
                <div className="col-md-4">
                  <TextField
                    type="number"
                    value={Item.quantityReceived}
                    onChange={({ target }) => {
                      handleItemUnitsChange(target);
                      setItemError({ ...ItemError, quantityReceived: "" });
                    }}
                    label="UNITS"
                    variant="standard"
                    id="standard-basic"
                    style={{ height: 42, width: "100%" }}
                  />
                  <span className="errors-msg-shown-for-goodsin">
                    {ItemError?.quantityReceived || ""}
                  </span>
                </div>
                <div
                  className="col-md-8 d-flex"
                  style={{ justifyContent: "space-between", marginTop: 3 }}
                >
                  <FormControl style={{ width: "250px" }} variant="standard">
                    <InputLabel id="demo-simple-select-standard-label">
                      STORAGE TYPE
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      onChange={({ target }) => {
                        ItemOncHangeData("storage", target.value);
                        setItemError({ ...ItemError, storage: "" });
                      }}
                      className="select-space-dropdown w-100"
                      label="storageType TYPE"
                      displayEmpty
                      value={Item.storage}
                    >
                      <MenuItem value="interior">INTERNAL</MenuItem>
                      <MenuItem value="exterior">EXTERNAL</MenuItem>
                    </Select>
                    <span className="errors-msg-shown-for-goodsin">
                      {ItemError?.storage || ""}
                    </span>
                  </FormControl>
                </div>
              </div>
            </div>
            <div
              className="col-md-5 d-flex mt-3"
              style={{ justifyContent: "flex-end" }}
            >
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                style={{ height: 40, marginRight: 13 }}
                // startIcon={<CancelIcon />}
                onClick={() => setOpen(!open)}
              >
                {Item?.shipmentItemEvidences?.length > 0 ?
                  <CollectionsIcon /> : <AddPhotoAlternateIcon />}
              </Button>
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                style={{ color: "red", borderColor: "red", height: 40 }}
                startIcon={<CancelIcon />}
                onClick={() => ClearItemData()}
              >
                CLEAR
              </Button>
              <Button
                variant="outlined"
                style={{ height: 40 }}
                className="btn-bootstrap-submit-style ms-3"
                startIcon={<AddCircleRoundedIcon />}
                onClick={addGoodsItem}
              >
                ADD ITEM
              </Button>
            </div>
            <div
              className="row mt-4 mb-4"
              style={{ borderBottom: "1px solid #0045d9" }}
            ></div>
          </div>
          <div className="row pt-1 pb-0 mb-2  ps-1">
            <InputLabel className="goodsin-form-section-header-name">
              {" "}
              Space
            </InputLabel>
          </div>
          <div className="row" style={{ height: 65 }}>
            <div className="col-md-2" style={{ position: "relative" }}>
              <TextField
                disabled={interiorCountItem?.length > 0 ? false : true}
                type="number"
                label="INTERNAL"
                {...register("internalSpaceOccupied")}
                value={GoodsInStateData?.internalSpaceOccupied}
                onChange={(e) => _GoodsInStateData({ ...GoodsInStateData, internalSpaceOccupied: parseFloat(e.target.value) })}
                variant="standard"
                id="standard-basic"
                style={{ height: 42, width: "100%" }}
              />
              <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
              <span className="errors-msg-shown-for-goodsin">
                {errors.internalSpaceOccupied?.message && errors.internalSpaceOccupied?.message}
              </span>
            </div>
            <div className="col-md-2 " style={{ position: "relative" }}>
              <TextField
                disabled={exteriorCountItem?.length > 0 ? false : true}
                type="number"
                {...register("externalSpaceOccupied")}
                label="EXTERNAL"
                value={GoodsInStateData.externalSpaceOccupied}
                onChange={(e) => _GoodsInStateData({ ...GoodsInStateData, externalSpaceOccupied: parseFloat(e.target.value) })}
                variant="standard"
                id="standard-basic"
                style={{ height: 42, width: "100%" }}
              />
              <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
              <span className="errors-msg-shown-for-goodsin">
                {errors.externalSpaceOccupied?.message && errors.externalSpaceOccupied?.message}
              </span>
            </div>
          </div>

          <div className="row pt-3 pb-0 mb-2 mt-2" style={{ marginLeft: -25 }}>
            <div className="col-md-2">
              <InputLabel className="goodsin-form-section-header-name">
                {" "}
                {imagesCount} PHOTOS
              </InputLabel>
            </div>
            <div className="col-md-10">
              {photoLoader && (
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            {newImagesArray
              .filter(
                (item) =>
                  item.typeId ==
                  lookupValues.find((v) => v.name === "Pictures").id &&
                  !item.isToBeDeleted
              )
              .map((d, index) => {
                return (
                  <div
                    key={index}
                    style={{ marginBottom: 2, width: 130, paddingTop: 10 }}
                  >
                    <Box
                      component="img"
                      style={{ height: 88, width: "100%" }}
                      alt="The house from the offer."
                      src={d?.url}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyItems: "center",
                        height: 20,
                        marginTop: 6,
                      }}
                      className="checkbox-style-class"
                    >
                      <Checkbox
                        style={{ color: "#E94F37" }}
                        checked={d.isDamaged}
                        onChange={({ target }) =>
                          IsDamageChangeHandler(target.checked, d.uniqueFileId)
                        }
                      />
                      <InputLabel
                        className="checkbox-label"
                        style={{
                          fontSize: 10,
                          fontFamily: "Montserrat-Regular",
                        }}
                      >
                        {" "}
                        DAMAGES
                      </InputLabel>
                    </div>
                    <div
                      onClick={() => {
                        let OldData = _.cloneDeep(newImagesArray);
                        _.remove(
                          OldData,
                          (i) => i.uniqueFileId === d.uniqueFileId
                        );
                        setNewImagesArray([...OldData]);
                      }}
                      style={{
                        display: "flex",
                        justifyItems: "center",
                        alignItems: "center",
                        paddingLeft: 4,
                        height: 20,
                        cursor: "pointer",
                      }}
                    >
                      <RemoveCircleOutlineOutlinedIcon
                        fontSize="20"
                        color="red"
                      />
                      <InputLabel
                        style={{
                          fontSize: 10,
                          marginBottom: 10,
                          color: "red",
                          fontFamily: "Montserrat-Regular",
                        }}
                      >
                        {" "}
                        REMOVE
                      </InputLabel>
                    </div>
                  </div>
                );
              })}
            <div style={{ marginBottom: 2, width: 130, paddingTop: 10 }}>
              <div className="row mt-2">
                <div className="fileUpload">
                  <input
                    type="file"
                    className="upload"
                    accept="image/png, image/jpeg, image/jpg"
                    multiple
                    onChange={(e) => photoUpload(e)}
                  />
                  <div
                    style={{
                      border: "1px solid #4879e2",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    <i
                      className="bi bi-plus-circle-fill"
                      style={{ color: "#4879e2" }}
                    ></i>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#0045d9",
                        fontFamily: "Montserrat-Regular",
                      }}
                    >
                      {" "}
                      ADD PHOTO
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
            <div className="col-md-2">
              <InputLabel className="goodsin-form-section-header-name">
                {" "}
                {documentCount} DOUCMENTS
              </InputLabel>
            </div>
            <div className="col-md-10">
              {documentLoader && (
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </div>
          </div>
          {newImagesArray
            .filter(
              (item) =>
                item.typeId ==
                lookupValues.find((v) => v.name === "Documents").id &&
                !item.isToBeDeleted
            )
            .map((d, index) => {
              return (
                <div key={index} className="row mt-2">
                  <div className="col-md-4">{d?.fileName || ""}</div>
                  <div className="col-md-4">
                    {/* <div style={{ width: "60%" }}>
                                <div className="progress">
                                    <div className="progress-bar" role="progressbar" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
                                </div>
                            </div> */}
                  </div>
                  <div
                    className="col-md-4"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      let OldData = _.cloneDeep(newImagesArray);
                      _.remove(
                        OldData,
                        (i) => i.uniqueFileId === d.uniqueFileId
                      );
                      setNewImagesArray([...OldData]);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyItems: "center",
                        color: "red",
                      }}
                    >
                      <RemoveCircleOutlineOutlinedIcon fontSize="20" />
                      <InputLabel
                        style={{ fontSize: 10, marginTop: -3, color: "red" }}
                      >
                        {" "}
                        Remove
                      </InputLabel>
                    </div>
                  </div>
                </div>
              );
            })}
          <div className="mt-3">
            <div className="fileUpload-doc">
              <input
                type="file"
                className="upload"
                multiple
                accept=".doc, .txt , .pdf"
                onChange={(e) => documentUpload(e)}
              />
              <div>
                <img src={IconNewRecord} alt="add" />
                <span className="add-doc-button-style">ADD DOCUMENT</span>
              </div>
              <div></div>
            </div>
          </div>
          {/* {userDetails?.roles == "SuperAdmin" &&
            <div
              className="return-checkbox-style"
              style={{ display: "flex", marginTop: 20 }}
            >
              <Checkbox
                checked={GoodsInStateData.isBackdatedEntry}
                style={{ color: "#0045D9", fontSize: 19 }}
                onChange={({ target }) => {
                  if (target.checked) {
                    _GoodsInStateData({ ...GoodsInStateData, isBackdatedEntry: true })
                  } else {
                    _GoodsInStateData({ ...GoodsInStateData, isBackdatedEntry: false })
                  }
                }}
              />
              <InputLabel
                style={{ marginTop: 5 }}
                className="return-keyword-style"
              >
                {" "}
                IS BACKDATED ENTRY
              </InputLabel>
            </div>} */}
          <div
            className="row mt-4 mb-4"
            style={{ borderBottom: "1px solid #0045d9" }}
          ></div>

          <div
            className="d-flex flex-row justify-content-between"
            style={{ marginTop: 10, marginBottom: 20 }}
          >
            <Button
              variant="outlined"
              className="btn-bootstrap-submit-style"
              style={{ color: "red", borderColor: "red" }}
              startIcon={<CancelIcon />}
              onClick={() => handleClose()}
            >
              Cancel
            </Button>
            {editData ? (
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                startIcon={<CheckCircleIcon />}
                type="submit"
              >
                Save
              </Button>
            ) : (
              <Button
                disabled={addNewGoodsInLoading ? true : false}
                variant="outlined"
                className={`btn-bootstrap-submit-style ${addNewGoodsInLoading ? "fade-out" : ""
                  }`}
                startIcon={<CheckCircleIcon />}
                type="submit"
              >
                Submit
              </Button>
            )}
          </div>
        </form>
      </div>
      <Modal
        open={open}
        onClose={handleClosemodal}
      >
        <Box sx={modalStyle}>

          <UploadImage
            toggle={handleClosemodal}
            Item={ItemDataForShowImage ? ItemDataForShowImage : Object.keys(Item).length > 0 ? Item : ItemDataForShowImage}
            setItem={(data) => {
              if (ItemDataForShowImage) {
                let mapdata = _.map(allItem, (d) => {
                  if (d.itemNumber === ItemDataForShowImage?.itemNumber) {
                    return data
                  }
                  else {
                    return d
                  }
                })
                setallItem([...mapdata])
              } else {
                setItem(data)
              }
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};
